// import store from '@/store'
import * as dd from 'dingtalk-jsapi'
import * as wx from 'jweixin-1.6.0'
import * as common from '@/api/common'
export default {
  data () {
    return {
      ptMode: {}
    }
  },
  setWxConfig (funcName) {
    let that = this
    let currentUrl = window.location.href
    if (this.ptMode) {
      return
    }
    common.getWxConfig({
      currentUrl: currentUrl
    }).then(data => {
      wx.config({
        debug: false,
        beta: true,
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: [
          'checkJsApi',
          'hideOptionMenu',
          'showOptionMenu',
          'hideMenuItems',
          'showMenuItems',
          'hideAllNonBaseMenuItem',
          'showAllNonBaseMenuItem',
          'closeWindow',
          'onHistoryBack',
          'scanQRCode'
        ]
      })
      wx.ready(function () {
        wx.hideOptionMenu()
      })
      that.ptMode = wx
      window.$.hideLoading()
    }).catch(err => {
      window.$.hideLoading()
      window.$.alert('加载微信配置失败！')
      console.log(err)
    })
  },
  scanCode (type, callback) {
    let pt = this.getBrowserType()
    if (pt === 'AliApp') {
      console.log(dd)
      dd.scan({
        type: type,
        success: callback
      })
    } else if (pt === 'wxwork' || pt === 'wx') {
      if (!this.ptMode) {
        console.log('=>没')
        window.$.showLoading()
        this.setWxConfig('scanCode')
      } else {
        console.log('=>有')
        type = type === 'all' ? ['qrCode', 'barCode'] : ((type === 'qr') ? ['qrCode'] : ['barCode'])
        let res = this.ptMode.scanQRCode({
          desc: 'scanQRCode desc',
          needResult: 1,
          scanType: type,
          success: callback,
          error: function (res) {
            if (res.errMsg.indexOf('function_not_exist') > 0) {
              alert('版本过低请升级')
            }
          }
        })
        console.log(res)
      }
    } else {
      alert('当前平台暂未对接扫码功能')
    }
  },
  setDomVW (domName, size, jisuan = 0) {
    let windowsVW = window.innerHeight / 100 * size + jisuan
    this.setDomVPX(domName, windowsVW, 'width')
  },
  setDomVH (domName, size, jisuan = 0) {
    let windowsVH = window.innerHeight / 100 * size + jisuan
    this.setDomVPX(domName, windowsVH, 'height')
  },
  setDomVPX (domName, pxSize, xy) {
    document.querySelector(domName).style.setProperty(xy, pxSize + 'px')
  },
  getCurrentTime () {
    let date = new Date() // 当前时间
    let year = date.getFullYear() // 返回指定日期的年份
    let month = this.repair(date.getMonth() + 1) // 月
    let day = this.repair(date.getDate()) // 日
    let hour = this.repair(date.getHours()) // 时
    let minute = this.repair(date.getMinutes()) // 分
    let second = this.repair(date.getSeconds()) // 秒
    // 当前时间
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
  },
  // 补0
  repair (i) {
    if (i >= 0 && i <= 9) {
      return '0' + i
    } else {
      return i
    }
  },
  /**
   * 格式化日期
   * @param second 时间戳
   * @param fmt    格式，例如: yyyy-MM-dd hh:mm:ss
   * @param isMs   是否带毫秒
   * @returns {string|*}
   */
  formatDate (second, fmt, isMs) {
    if (!second || !fmt || isNaN(second)) {
      return ''
    }
    let date = new Date(isMs ? second : second * 1000)
    let tObj = {
      M: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      m: date.getMinutes(),
      s: date.getSeconds()
    }
    fmt = fmt.replace(/y+/, date.getFullYear())
    for (let key in tObj) {
      if (new RegExp('(' + key + '+)').test(fmt)) {
        if (RegExp.$1.length === 1) {
          fmt = fmt.replace(RegExp.$1, tObj[key])
        } else {
          fmt = fmt.replace(RegExp.$1, ('00' + tObj[key]).slice((tObj[key] + '').length))
        }
      }
    }
    return fmt
  },

  showToast (err) {
    if (!err) {
      return
    }
    let msg = ''
    if (typeof err === 'string') {
      msg = err
    } else {
      msg = err.em || err.message || err.errMsg || '服务开小差了，请稍后重试'
    }
    alert(msg)
    // store.dispatch('openToast', msg)
  },
  // 判断是不是微信
  isWx () {
    return this.getBrowserType().indexOf('wx') > -1
  },
  // 判断是不是iOS
  isIOS () {
    let ua = navigator.userAgent.toLowerCase()
    return ua && /iphone|ipad|ipod|ios/.test(ua)
  },
  // 获取URL中的参数
  getUrlKey (name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || ['', ''])[1].replace(/\+/g, '%20')) || null
  },
  getBrowserType () {
    let ua = navigator.userAgent.toLowerCase()
    if (ua.indexOf('micromessenger') !== -1) {
      return (ua.indexOf('wxwork') !== -1) ? 'wxwork' : 'wx'
    } else if (ua.indexOf('aliapp') !== -1 || ua.indexOf('dingtalk') !== -1) {
      return 'AliApp'
    } else {
      return ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/utils.js